import { useState, useEffect } from 'react'

// Single-insight fetch for the /insights/:id detail page.
// Bypasses HTTP cache so a fresh body_md backfill shows immediately
// without forcing the user to hard-refresh.
export function useInsightDetail(id) {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!id) return
    let cancelled = false
    setLoading(true)
    setError(null)
    fetch(`/api/insights/${encodeURIComponent(id)}`, { cache: 'no-store' })
      .then((r) => r.ok ? r.json() : Promise.reject(`HTTP ${r.status}`))
      .then((d) => {
        if (cancelled) return
        if (d.error) { setError(d.error); setData(null) }
        else { setData(d); setError(null) }
        setLoading(false)
      })
      .catch((e) => {
        if (cancelled) return
        setError(String(e))
        setLoading(false)
      })
    return () => { cancelled = true }
  }, [id])

  return { insight: data, loading, error }
}
